import { useTranslation } from "react-i18next";

function SchoolGallery() {
  const { i18n, t } = useTranslation();

  return (
    <div
      id="SchoolGallery"
      className="flex font-ar max-w-[717px] w-[calc(60vw)] mobile:ml-0 bg-white rounded-lg mobile:shadow-none mobile:w-[calc(100vw-32px)] mobile:mr-0 mobile:h-fit items-center content-center justify-center drop-shadow-[0_0px_20px_rgba(0,0,0,0.05)]"
    >
      <div className="mobile:px-4 h-[371px] mt-8 mobile:w-[calc(100vw-48px)] mobile:h-fit">
        <div className="mobile:w-[325px] mobile:h-[22px]">
          <p className="mobile:text-mint-500 mobile:text-xl mobile:font-medium">
            {t("schoolInfo.container.schoolPicture")}
          </p>
        </div>
        <p className="pt-4 text-zinc-700 text-xl font-arMedium">
          {t("schoolGallery.container.coverImage")}
        </p>
        <div
          className={`${
            i18n.language === "ar"
              ? "flex-row justify-start"
              : "flex-row-reverse justify-end"
          } flex gap-4 items-center mobile:w-[175px] pt-2`}
        >
          <button className="w-[37px] h-[22px] justify-center text-[13px] text-[#4F46E5] font-arBold">
            {t("schoolGallery.container.update")}
          </button>
          <div className="w-[71px] h-[71px]">
            <img
              alt=""
              src="/assets/images/school1b.jpeg"
              className="rounded-lg w-[71px] h-[71px]"
            />
          </div>
        </div>
        <p className="mt-8 pt-4 text-zinc-700 text-xl font-arMedium">
          {t("schoolGallery.container.additionalImages")}
        </p>
        <div className="flex flex-row w-[546px] justify-between tablet:w-96 h-[111px] mobile:w-[calc(100vw-68px)] mobile:h-fit pt-2">
          <div className="w-[71px] h-[111px] justify-center items-center mb-4 text-center">
            <div className="w-[71px] h-[71px] mb-4">
              <img
                alt=""
                src="/assets/images/school1b.jpeg"
                className="rounded-lg w-[71px] h-[71px]"
              />
            </div>
            <button className="items-center justify-center content-center text-center text-[13px] text-[#4F46E5] font-arBold">
              {t("schoolGallery.container.update")}
            </button>
          </div>
          <div className="w-[71px] h-[111px] justify-center items-center mb-4 text-center ">
            <div className="w-[71px] h-[71px] mb-4">
              <img
                alt=""
                src="/assets/images/school1b.jpeg"
                className="rounded-lg w-[71px] h-[71px]"
              />
            </div>
            <button className=" items-center justify-center content-center text-center text-[13px] text-[#4F46E5] font-arBold">
              {t("schoolGallery.container.update")}
            </button>
          </div>
          <div className="w-[71px] h-[111px] justify-center items-center mb-4 text-center">
            <div className="w-[71px] h-[71px] mb-4">
              <img
                alt=""
                src="/assets/images/school1b.jpeg"
                className="rounded-lg w-[71px] h-[71px]"
              />
            </div>
            <button className="items-center justify-center content-center text-center text-[13px] text-[#4F46E5] font-arBold">
              {t("schoolGallery.container.update")}
            </button>
          </div>
          <div className="w-[71px] h-[111px] justify-center items-center mb-4 text-center">
            <div className="w-[71px] h-[71px] mb-4">
              <img
                alt=""
                src="/assets/images/school1b.jpeg"
                className="rounded-lg w-[71px] h-[71px]"
              />
            </div>
            <button className="items-center justify-center content-center text-center text-[13px] text-[#4F46E5] font-arBold">
              {t("schoolGallery.container.update")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SchoolGallery;
